import React from 'react';
import ItemOnlineReportHeader from './ItemOnlineReportHeader';
import ItemOnlineReportContent from './ItemOnlineReportContent';

const ItemOnlineReportCEO = () => {
    return (
        <>
            <ItemOnlineReportHeader />
            <ItemOnlineReportContent />
        </>
    );
};

export default ItemOnlineReportCEO;
